export default __webpack_public_path__ + "static/media/loading.6fdf6f7f.gif";